import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthorBioModalComponent } from '../author-bio-modal/author-bio-modal.component';

@Component({
  selector: 'app-course-author-list',
  templateUrl: './course-author-list.component.html',
  styleUrls: ['./course-author-list.component.scss']
})
export class CourseAuthorListComponent implements OnInit {
  @Input() public authors: object[];
  @Input() private link: boolean;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  openAuthorBio(authorId) {
    const modalRef = this.modalService.open(AuthorBioModalComponent);
    modalRef.componentInstance.authorId = authorId;
    return false;
  }

}
